import { useContext } from 'react';
import { ChatApiClientContext } from './contexts';

export const useChatApiClient = () => {
  const context = useContext(ChatApiClientContext);
  if (!context) {
    throw new Error('useChatApiClient must be used within a ChatApiClientProvider');
  }
  return context;
};